// AssignPingingVideo.jsx

import PingingDataTable from "../../components/PingingDataTable/PingingDataTable";

const AssignPingingVideo = () => {
  return (
    <PingingDataTable
      title="Pinging Report - Lesson Pages"
      apiEndpoint="/pinging-assignment"
      defaultValue="video_all"
      showVideoColumns={true}
      showPlayVideo={true}
      type="assign"
      pingType="video"
      toolId={6}
    />
  );
};

export default AssignPingingVideo;
